<template>
	<vx-tooltip :text="getToolTipText()">
		<vs-button color="primary" @click.native="printShippingLabel" :disabled="isButtonDisabled()">
			<font-awesome-icon :icon="['fas', 'print']" class="fa-icon" />
		</vs-button>
	</vx-tooltip>
</template>

<script>
import dymoPrinter from '@/services/dymo/dymoPrinter';
import dymoLabels from '@/services/dymo/dymoLabels';

export default {
	props: {
		order: {
			type: Object,
			required: true,
		},
		dymoPrinter: {
			type: dymoPrinter,
			required: true
		}
	},
	methods: {
		getToolTipText() {
			if (!this.dymoPrinter.shippingPrinterReady()) {
				return 'Er is geen verbinding met de adres label printer';
			}

			return 'Print adres label';
		},
		isButtonDisabled() {
			return !this.dymoPrinter.shippingPrinterReady();
		},
		printShippingLabel() {
			this.dymoPrinter.printShippingLabel(this.order);
		},
	}
}
</script>
